import {DateTime} from "luxon";

export const formatPlate = (v) => v.replace(/[^a-z0-9]/gi, '').toUpperCase();

export const fmtDate = (isoDate, timezone, fmt = 'yyyy-MM-dd H:mm a') => {
  if (!isoDate) return '-'
  return DateTime.fromISO(isoDate, { zone: timezone }).toFormat(fmt);
}

/*
 * Feature config values can come back from the Admin Features editor as plain
 * strings rather than their native type (e.g. the boolean true serialised as
 * the string "true"). Coerce to a real boolean so toggle logic stays correct:
 * "false" must read as false, not as a truthy non-empty string.
 */
export const toBoolean = (value) => value === true || value === 'true';